export const isAlphanumericText = (comment: string) => {
  const alphanumRegex = /[a-zA-Z0-9_]/;

  return alphanumRegex.test(comment);
};
